'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTargetCrosshairs, iconTargetCrosshairsTag } from '@ni/nimble-components/dist/esm/icons/target-crosshairs';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTargetCrosshairs };
export { iconTargetCrosshairsTag };
export const NimbleIconTargetCrosshairs = wrap(IconTargetCrosshairs);